// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientRepresentativeController_UpdateById_Input_Gender,
  MutationInput_LegalClientRepresentativeController_UpdateById_Input_RoleInCompany_RoleInCompany,
  MutationInput_LegalClientRepresentativeController_UpdateById_Input_PepConnectionType as PepConnectionTypeApi,
  UpdateLegalClientRepresentativeByAdminDto_Input,
} from 'api/generated/graphql';
import { RelationType } from 'api/types/entity';
import { UpdateLegalClientRepresentativeParams } from 'api/types/params';
import { isGlobalProject } from 'config';
import { formatToISODate } from 'helpers';

import { parseBiographyParam } from '../client/parseParam';
import { parseConstitutionalDocumentParam } from '../legal/parseParam';
import { parseIdentityDocumentParam } from '../parseParam';

const relationType: Record<RelationType, PepConnectionTypeApi> = {
  [RelationType.not]: PepConnectionTypeApi.None,
  [RelationType.yesSpouses]: PepConnectionTypeApi.FamilyMember,
  [RelationType.yesIAm]: PepConnectionTypeApi.Self,
};

const isGlobal = isGlobalProject();

export const parseUpdateLegalClientRepresentativeParams = (
  params: UpdateLegalClientRepresentativeParams
): UpdateLegalClientRepresentativeByAdminDto_Input => ({
  versionNumber: params.versionNumber,
  reason: params.reason,

  firstName: params.firstName,
  lastName: params.lastName,
  middleName: params.middleName,
  dateOfBirth: formatToISODate(params.dateOfBirth),

  gender: params.gender
    ? MutationInput_LegalClientRepresentativeController_UpdateById_Input_Gender[
        params.gender
      ]
    : undefined,
  citizenships: params.citizenships,
  biography: params.biography
    ? parseBiographyParam(params.biography)
    : undefined,

  placeOfBirth: params.placeOfBirth,
  registrationAddress: params.registrationAddress,
  residentialAddress: params.residentialAddress,
  taxResidences: params.taxResidences,

  connectedPepInfo: params.connectedPepInfo,

  pepConnectionType: relationType[params.pepConnection],

  company: params.company
    ? {
        actualAddress: params.company.actualAddress,
        legalAddress: params.company.legalAddress,
        fullName: params.company.fullName,
        shortName: params.company.shortName,
        constitutionalDocument: parseConstitutionalDocumentParam(
          params.company.constitutionalDocument
        ),
        stateRegistration: params.company.stateRegistration,
        taxResidences: params.company.taxResidences,
      }
    : undefined,

  roleInCompany: {
    roleInCompany:
      isGlobal && params.roleInCompany.roleInCompany
        ? MutationInput_LegalClientRepresentativeController_UpdateById_Input_RoleInCompany_RoleInCompany[
            params.roleInCompany.roleInCompany
          ]
        : undefined,
    authorityConfirmationDocument: {
      dateOfExpiration: params.roleInCompany.authorityConfirmationDocument
        .dateOfExpiration
        ? formatToISODate(
            params.roleInCompany.authorityConfirmationDocument.dateOfExpiration
          )
        : null,
      dateOfIssue: formatToISODate(
        params.roleInCompany.authorityConfirmationDocument.dateOfIssue
      ),
      fileIds: params.roleInCompany.authorityConfirmationDocument.fileIds,
      number: params.roleInCompany.authorityConfirmationDocument.number,
    },
  },
  additionalInformationFileIds: params.additionalInformationFileIds,
  additionalDocumentFileIds: params.additionalDocumentFileIds,

  identityDocument: parseIdentityDocumentParam(params.identityDocument),
  selfieFileIds: params.selfieFileIds,
});
